import React from "react";
import CancelFooterOption from "./CancelFooterOption";

export default ({ state }) => {
  return <CancelFooterOption state={state} />;
};
